import React from "react";
import { useNavigate } from "react-router-dom";
import "./HomePage.css"; // ✅ We'll create CSS file

const HomePage = ({ onLogout }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    if (onLogout) onLogout();
    navigate("/"); // ✅ Redirect to Login
  };

  const products = [
    {
      name: "Millet-Based Beverage",
      description: "A healthy drink made from super grains.",
      image: "https://images.unsplash.com/photo-1606312617284-0e8f87a3b9b7", // Sample image
    },
    {
      name: "Drumstick Protein Powder",
      description: "Rich in protein & immunity boosters.",
      image: "https://images.unsplash.com/photo-1615874959474-7f6b5e9eaf08", // Sample image
    },
    {
      name: "Curcumin Peanut Butter",
      description: "Delicious and anti-inflammatory snack.",
      image: "https://images.unsplash.com/photo-1590080875512-7d9d53f7c213", // Sample image
    },
  ];

  return (
    <div className="homepage-container">
      <h2 className="homepage-title">Welcome to Plant Protein World 🌱</h2>
      <p className="homepage-subtitle">
        Explore our range of healthy and delicious plant-based products.
      </p>

      {/* ✅ Product Grid */}
      <div className="product-grid">
        {products.map((product, index) => (
          <div key={index} className="product-card">
            <img src={product.image} alt={product.name} className="product-image" />
            <h3>{product.name}</h3>
            <p>{product.description}</p>
          </div>
        ))}
      </div>

      {/* ✅ Logout Button */}
      <button className="logout-button" onClick={handleLogout}>
        Logout
      </button>
    </div>
  );
};

export default HomePage;
